<div class="content-counter-piece" [ngClass]="matStyle ? 'counter-pieces-mat-style':''">
  <div class="content-piece-fuction cursosPointer content-counter-piece-less font-omicron-medium" (click)="decrement()"
    [matTooltip]="toolTipTextDelete">-</div>
  <div class="content-piece-fuction">
    <input id="pieces" type="text" mask="000000" matInput [(ngModel)]="pieceInit" (ngModelChange)="submitPiece()"
      (input)="patternService.inputNumbersOnly($event, pieceInit)"
      (keypress)="patternService.inputNumbersOnly($event, pieceInit)" maxlength="6" />
  </div>
  <div class="content-piece-fuction cursosPointer font-omicron-bold content-counter-piece-more" (click)="inclement()"
    [matTooltip]="toolTipTextAdd">+</div>
</div>